import React from 'react';
import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import './style.scss';

interface IProps extends ButtonProps {}

export class WhiteButton extends React.Component<IProps, null> {
  render(): React.ReactNode {
    return (
      <Button {...this.props} className={`white-button ${this.props.className ? this.props.className : ''}`}>
        {this.props.children}
      </Button>
    );
  }
}
